import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import HoverCard from 'src/componentes/hover-card';
import LucideIcon from 'src/componentes/lucide-icon';
import ListRisco from 'src/paginas/gestao-risco/risco/RiscoListView';
import ContentManager from 'src/componentes/content-manager';
import { capitalizeFirstLetter } from 'src/utils/string';
import formatarScoreRisco from 'src/utils/formatarScoreRisco';

import './index.css';

/**
 Erro1: O componente fica piscando na tela ao passar o mouse sobre
 Solução:
    O pai desse componente não deve conter a propriedade de css OverFlowY: auto. Por Default, no componente List é dado essa propriedade. 
    Pra remover é só passar como parametro no List a propriedade showScrollColumn=false
 * 
 * 
 * @param {object} scoreAcumuladoDoGrau representa o número de risco num determinado grau. Referencia: GDR-337  
 */
const ScoreAcumulado = ({
  scoreAcumuladoDoGrau,
  resources,
  showPopOver = true,
  showLabel = false,
  showValue = true,
  intl,
  style,
  thousandsSeparator = '.',
  decimalSeparator = ',',
}) => {
  const getTotal = () => {
    if (!scoreAcumuladoDoGrau || scoreAcumuladoDoGrau.length == 0 || !showValue)
      return '';

    const total = scoreAcumuladoDoGrau.reduce(
      (acc, current) => acc + (parseFloat(current.scoreAcumulado) || 0),
      0
    );

    return formatarScoreRisco(total, thousandsSeparator, decimalSeparator);
  };

  const renderLabel = () => {
    const frase = intl
      .formatMessage({ id: 'scoreAcumulado' }, { risco: resources.risco })
      .split(' ');
    return frase[0] + ' ' + frase[2];
  };

  const handleRiscoClick = (riscoAvaliacoes) => {
    let keys = [];

    if (riscoAvaliacoes) {
      riscoAvaliacoes.forEach((x) => {
        if (x && x.riscos) x.riscos.forEach((risco) => keys.push(risco.id));
      });

      if (keys && keys.length > 0) {
        ContentManager.addContent(
          <ListRisco
            openLastFilter={true}
            usarFiltroSalvo={true}
            showModal={true}
            showNew={false}
            params={{ idsSelecionados: keys }}
            title={capitalizeFirstLetter(resources.risco)}
            ignoreCloseModal={true}
          />
        );
      }
    }
  };

  const barra = (
    <div className="scoreAcumuladoSpacos">
      {scoreAcumuladoDoGrau?.map(({ grau: { cor }, riscos }, index) => (
        <div
          key={index}
          onClick={handleRiscoClick.bind(this, scoreAcumuladoDoGrau)}
          style={{ display: 'flex', flex: riscos.length, background: cor }}
        />
      ))}
    </div>
  );

  return (
    <div className="scoreAcumulado" style={{ cursor: 'pointer', ...style }}>
      <span style={{ marginRight: showValue ? 5 : -5 }}>
        {showLabel && renderLabel()}
        <strong style={{ marginLeft: showValue ? 1 : 0, marginRight: 5 }}>
          {getTotal()}
        </strong>
      </span>

      {showPopOver ? (
        <HoverCard
          placement="right"
          className="tw:px-4 tw:py-2"
          content={scoreAcumuladoDoGrau?.map(
            ({ grau: { cor }, riscos }, index) => (
              <div key={index} className="tw:flex tw:items-center tw:py-1">
                <LucideIcon icon="circle" color={cor} size={22} />
                {riscos.length}{' '}
                {riscos.length > 1 ? resources.riscos : resources.risco}
              </div>
            )
          )}
        >
          {barra}
        </HoverCard>
      ) : (
        barra
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(ScoreAcumulado));
